<template>
  <div class="legaledit-container">
    <div class="legaledit-table">
      <b-list-group>
        <b-list-group-item v-for="(field, index) in fields" :key="index">
          <div
            class="d-flex w-100 justify-content-between informations-item-title"
            style="font-size:.5rem"
          >
            <h5 class="mb-2">{{ field.label }}</h5>
          </div>
          <div>
            <p
              class="mb-0"
              style="font-size: .7rem"
              v-if="field.key == 'bidang_usaha'"
            >
              <b-form-input
                type="text"
                placeholder="Bidang Usaha"
                v-model="item[field.key]"
              />
            </p>
            <p class="mb-0" style="font-size: .7rem" v-else>
              <b-form-select
                :options="[
                  { value: true, text: 'Yes' },
                  { value: false, text: 'No' },
                ]"
                v-model="item[field.key]"
                class="list-menu"
              ></b-form-select>
            </p>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div class="legaledit-btn">
      <b-button class="btn-edit mr-1" @click="cancelEdit">Cancel</b-button>
      <b-button class="btn-edit mr-1" @click="saveEdit">Save</b-button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '../services/config'
export default {
  name: 'addlegal',
  data() {
    return {
      fields: [
        { key: 'bidang_usaha', label: 'Bidang Usaha' },
        {
          key: 'formulir_informasi_vendor',
          label: 'Formulir Informasi vendor',
        },
        { key: 'informasi_rekening', label: 'Informasi rekening' },
        { key: 'ktp_pengurus', label: 'KTP Pengurus' },
        { key: 'kartu_keluarga', label: 'Kartu Keluarga' },
        { key: 'akta_pendirian_perseroan', label: 'Akta Pendirian Perseroan' },
        { key: 'akta_penyesuaian_pt', label: 'Akta Penyesuaian PT' },
        {
          key: 'anggaran_dasar_terakhir_perseroan',
          label: 'Anggaran Dasar Terakhir Perseroan',
        },
        {
          key: 'akta_perubahan_pengurus_terakhir_perseroan',
          label: 'Akata Perubahan Pengurus Terakhir Perseroan',
        },
        { key: 'npwp', label: 'NPWP' },
        { key: 'sppkp_pajak', label: 'SPPKP Pajak' },
        { key: 'skt_pajak', label: 'SKT Pajak' },
        { key: 'sk_domisili_situ_ig', label: 'SK Domisili SITU IG' },
        { key: 'siup', label: 'SIUP' },
        { key: 'nib', label: 'NIB' },
        { key: 'tdp', label: 'TDP' },
        { key: 'sbu', label: 'SBU' },
        { key: 'iujk', label: 'IUJK' },
        { key: 'iu_pelayaran', label: 'IU Pelayaran' },
        { key: 'iujp', label: 'IUJP' },
        { key: 'iu_niaga', label: 'IU Niaga' },
        { key: 'financial_report', label: 'Financial Report' },
      ],
      item: {
        bidang_usaha: null,
        formulir_informasi_vendor: false,
        informasi_rekening: false,
        ktp_pengurus: false,
        kartu_keluarga: false,
        akta_pendirian_perseroan: false,
        akta_penyesuaian_pt: false,
        anggaran_dasar_terakhir_perseroan: false,
        akta_perubahan_pengurus_terakhir_perseroan: false,
        npwp: false,
        sppkp_pajak: false,
        skt_pajak: false,
        sk_domisili_situ_ig: false,
        siup: false,
        nib: false,
        tdp: false,
        sbu: false,
        iujk: false,
        iu_pelayaran: false,
        iujp: false,
        iu_niaga: false,
        financial_report: false,
      },
    }
  },
  created() {
    const self = this
    self.$store.dispatch('toggleSidebar', false)
  },
  methods: {
    cancelEdit() {
      const self = this
      self.$router.push({ name: 'legalconfig' })
    },
    async saveEdit() {
      this.$ga.event({
        eventCategory: 'Legal ADD FORM',
        eventAction: 'click',
        eventLabel: `SAVE`,
      })
      const self = this
      try {
        if (self.item.bidang_usaha !== null && self.item.bidang_usaha !== '') {
          const { data } = await axios({
            method: 'POST',
            url: `${api}/api/v1/legal`,
            headers: {
              'Content-Type': 'application/json',
            },
            data: self.item,
          })
          if (data && data.status == 'success') {
            await self.$router.push({ name: 'legalconfig' })
            await self.$bvToast.toast(data.message, {
              title: data.status,
              toaster: 'b-toaster-top-center',
              solid: true,
              appendToast: false,
              variant: 'success',
            })
          }
        } else {
          await self.$bvToast.toast('Bidang usaha can not empty', {
            title: 'Add Failed!',
            toaster: 'b-toaster-top-center',
            solid: true,
            appendToast: false,
            variant: 'danger',
          })
        }
      } catch (error) {}
    },
  },
}
</script>
<style lang="scss">
@import '~/assets/scss/components/legaledit.scss';
</style>
